// extracted by mini-css-extract-plugin
export default {"templateJsonInput":"update-template-json-modal__template-json-input__Wz_az"};